export const GAME_NAMES = ["SF6", "SFV", "USF4", "3S", "GGST"] as const;
